import { ModalProps } from 'rsuite/lib/Modal';
import { ActionFeedbackDialog } from '../../../../../../../../components';

export type ErroProcessamentoArquivoModalProps = ModalProps & {
  onHide?: () => void;
  onTentarNovamente?: () => void;
};

export const ErroProcessamentoArquivoModal = ({ show, onHide, onTentarNovamente }: ErroProcessamentoArquivoModalProps) => {
  const handlePrimaryAction = () => {
    onTentarNovamente?.();
    onHide?.();
  };

  return (
    <ActionFeedbackDialog
      open={Boolean(show)}
      type="error"
      title="Não foi possível processar o arquivo"
      description={
        <>
          O arquivo pode estar com formato inválido, colunas incorretas ou exceder o limite de 1.000 linhas. Envie um CSV ou XLSX com as colunas Product ID e
          Preço Unitário.
        </>
      }
      onClose={onHide}
      primaryAction={{
        label: 'TENTAR NOVAMENTE',
        onClick: handlePrimaryAction,
      }}
    />
  );
};
